const withdrawalAgreement = {
  id: 'withdrawal-agreement-en',
  title: 'Withdrawal agreement',
  body: `
  <ol>
  <li>
      The correspondent bank may charge a fee for transferring funds. Please            contact your bank to determine if you will be charged any fees.
  </li>
  <li>
      If you are withdrawing funds not in the Partners Office's source currency (Russian rubles), the amount you are withdrawing will be converted. The currency is converted            at the current exchange rate of the European Central Bank             for the day of the transaction.
  </li>
  <li>
      The funds can be withdrawn only to the credit/debit card or the bank account of the person            indicated during verification in the Partners Office. It's not possible to withdraw funds            to third party accounts.
  </li>
  <li>
      To withdraw funds you must provide the following documents and information.
      <ol>
      <li>
          To withdraw funds for legal entities you need to provide the following                documents: INN (Tax Identification Number), OGRN (Major State Registration Number) (for Russian Federation residents) or
          analogous documents (for residents of other countries) and bank account
          information to tatyanak@super-ego.info and fill out a request.
      </li>
      <li>
          To withdraw funds to a credit or debit card you need to provide your card information on                a special payment page (complies with PCI DSS card payment security standards) and fill out
          a request. We don't store or use your credit or debit card information.
      </li>
      </ol>
  </li>
  <li>
      You are responsible for paying taxes on the transferred funds in accordance with the laws of your country of residence.
  </li>
  <li>
      Funds are will be reflected on your credit/debit card or bank account statement within 10 business days (approximately, the exact time frame depends on your bank).
  </li>
  </ol>
  <p>
  For any questions regarding funds withdrawal please either contact Customer Support Service or make a phone call to +79662406130 (fees may apply, please check with your service provider).
  </p>
  `,
}

export default withdrawalAgreement
